// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__HrubL","item":"Sidebar_item__UxC8B","icon":"Sidebar_icon__wQ6Mc","tooltip":"Sidebar_tooltip__28VnQ","active":"Sidebar_active__AF0gR"};